<template>
  <a class="btn btn-plain" @click="addPatient">
    <AddSvg/>
    <span class="d-none d-xl-inline header-title">{{ $t('add_patient') }}</span>
  </a>
</template>

<script setup>
import AddSvg from '@/assets/svg-vue/header/adduser.svg'
import { computed } from "vue"
import { useStore } from "vuex"

const store = useStore()

const branch = computed(() => store.state.auth.branch)

// the patient form for the current branch
const addPatient = () => {
  store.commit('setViewModel', 'patient')
  store.commit('setModule', 'patients')
  store.commit('setSelectedModel', {
    branch_id: branch.value
  })
  store.commit('setShowModal', true)
}
</script>
